export default __webpack_public_path__ + "static/media/codeSee@2x.1797c652.svg";